<template>
  <div class="form-container">
    <template v-if="forms.length">
      <div class="border p-3 card-sr-information-form mb-3" v-for="(form, index) in forms" :key="index"
        :id="`form-subcon-${index}`">
        <b-row>
          <b-col md="12">
            <h5 class="text-primary mb-2"><strong>Sub Contractor</strong></h5>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="company">Company</label>
            <b-form-input v-model="form.subkon_name" class="bg-white" id="company"></b-form-input>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="pic">PIC</label>
            <b-form-input v-model="form.subkon_pic" class="bg-white" id="pic"></b-form-input>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="email">Email</label>
            <b-form-input v-model="form.subkon_pic_email" class="bg-white" id="email"></b-form-input>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="phone">Phone</label>
            <b-form-input v-model="form.subkon_pic_phone" class="bg-white" id="phone"></b-form-input>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="cost">Est. Cost Sub Contractor</label>
            <b-input-group prepend="Rp">
              <b-form-input class="bg-white" v-model="form.subkon_price_deal" id="cost" type="number"></b-form-input>
            </b-input-group>
            <small> {{ formatCurrency(form.subkon_price_deal) }}</small>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="phone2">Phone 2</label>
            <b-form-input class="bg-white" id="phone2" v-model="form.phone2" type="number"></b-form-input>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="attachment">Sub Contractor Attachment <span class="text-red">*</span></label>
            <b-form-file class="mb-2" v-model="form.subkon_file" multiple required
              @input="(val) => handleInputFiles(val, form)"></b-form-file>
          </b-col>
          <b-col md="12">
            <b-row class="m-0">
              <b-col lg="2" class="p-0 pr-2 mb-3" v-for="(file, idx) in form.filePreview" :key="`${index}-${idx}`">
                <AttachmentSR :modelId="form.id" modelName="sr_form_repair_entity" :file="file" @delete="() => handleDeleteFile(form, idx)" />
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-3">
            <label for="remark">Remark</label>
            <b-form-textarea id="remark" placeholder="input remarks..." rows="3" class="bg-white"
              v-model="form.subkon_notes"></b-form-textarea>
          </b-col>
        </b-row>
      </div>
    </template>
  </div>
</template>
<script>
import AttachmentSR from './AttachmentSR.vue'

export default {
  name: 'FormSubcon',
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    selectedIndex: null
  },
  data() {
    return {}
  },
  components: {
    AttachmentSR,
  },
  methods: {
    handleInputFiles(val, item) {
      if (!val) return false
      const files = val
      if (files.length) {
        Array.from(files).forEach((file) => {
          item.filePreview?.push({
            url: URL.createObjectURL(file),
            name: file.name,
          })
        })
      }
    },
    handleDeleteFile(item, idx) {
      const newFiles = item.filePreview.filter((_, i) => i !== idx)
      const newFileUploads = item.subkon_file.filter((_, i) => i !== idx)
      item.filePreview = newFiles
      item.subkon_file = newFileUploads
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    scrollToSection(id) {
      console.log(id);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  watch: {
    forms: {
      handler(newVal) {
        if (newVal.length) {
          this.scrollToSection(`form-subcon-${newVal.length - 1}`)
        }
      },
      deep: true,
    },
  }
}
</script>
<style scoped>
.form-container {
  max-height: 70vh;
  overflow: auto;
}

.card-sr-information-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.text-red {
  color: red;
}
</style>
